define('lq/events/actions/refreshLoggedInUserCommand',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function RefreshLoggedInUserCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(RefreshLoggedInUserCommand, EventAction);

    RefreshLoggedInUserCommand.typeName = 'RefreshLoggedInUserCommand';

    RefreshLoggedInUserCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    RefreshLoggedInUserCommand.prototype.execute = function (continuation) {
        this.piping.dispatcher.dispatch('LicquidAction/RefreshLoggedInUser')
            .then(function () {
                continuation();
            });
    };

    return RefreshLoggedInUserCommand;
});
